import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../Contexts/UserContext";
import { AdminContext } from "../../Contexts/AdminContext";
import instance from "../../instance/AxiosInstance";
import { toast } from "react-toastify";

const GoogleAuthSuccess = () => {
  const navigate = useNavigate();
  const { SetUser } = useContext(UserContext);
  const { SetAdmin } = useContext(AdminContext) || {};

  const isMobileDevice = () => {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent);
};
  const handleNotificationPermission = (userId ,name ,email) => {
    const notification = localStorage.getItem("pshdsadhgsa");
    if (notification && userId) {
      instance
        .post("api/update_notification_permision", { userId, notification , name , email })
        .then((res) => {
          console.log("Notification permission updated:", res.data);
        })
        .catch((err) => {
          console.error("Error updating notification permission:", err);
        });
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const message = urlParams.get("message");
    const status = urlParams.get("status");
    const token = urlParams.get("token");
    const userString = urlParams.get("user");

    if (!token || !userString) {
      toast.error("Authentication failed. Missing token or user data.");
      navigate("/registration_login");
      return;
    }

    const user = JSON.parse(decodeURIComponent(userString));

    if (status === "403") {
      toast.error("Account is deleted. Please contact support.");
      navigate("/registration_login");
      return;
    }

    handleNotificationPermission(user._id ,user.fullname ,user.email);

    if (user.role === "superadmin" || user.role === "admin") {
      localStorage.setItem("AdminLogged", "true");
      localStorage.setItem("AdminToken", token);
      SetAdmin(user);
      navigate("/admin");
    } else {
      localStorage.setItem("logged", "true");
      localStorage.setItem("token", token);
        localStorage.setItem("hasSignedUp",true)
        localStorage.setItem("Gdpr",true)
      SetUser(user);
      if (isMobileDevice()) {
      navigate('/profile/selectlocation');
    } else {
      navigate('/');
    }
    }
  }, []);

  return <div>Redirecting...</div>; // Optional: show while redirecting
};

export default GoogleAuthSuccess;
